<template>
  <div class="player-props" :class="[{'one-event': oneEvent}]">
    <div class="props-container props" :class="[{'team-logo': displayLogos}]">
      <div class="props-holder" @click.stop="headerClick(event)">
        <div class="title-wrapper">
          <div class="home item">
            <div v-if="displayLogos" class="item logo home">
              <img :src="logosSource">
            </div>
            <div v-if="!isAmerican && event.participantname_home" class="item player-props-home">{{event.participantname_home}}</div>
            <div v-if="isAmerican && event.participantname_away" class="item player-props-home">{{event.participantname_away}}</div>
            <div v-if="!event.participantname_home && !event.participantname_away && event.eventname" class="item player-props-home">{{event.eventname}}</div>
          </div>
          <div class="item time">
            <span v-if="event.tsstart && isDateToday(event.tsstart)">{{ $t('PlayerProps.Event.Today') }} {{ (event.tsstart) | moment(dateFormats.longTime)}}</span>
            <span v-if="event.tsstart && isDateTomorrow(event.tsstart)">{{ $t('PlayerProps.Event.Tomorrow') }} {{ (event.tsstart) | moment(dateFormats.longTime)}}</span>
            <span v-if="event.tsstart && !isDateToday(event.tsstart) && !isDateTomorrow(event.tsstart)">{{ event.tsstart | moment(dateFormats.dayAndMonthAndDateUS) }} </span>
            <span v-if="timeZone">[{{ timeZone }}]</span>
          </div>
          <div class="away item">
            <div v-if="displayLogos" class="item logo away">
              <img :src="logosSource">
            </div>
            <div v-if="!isAmerican && event.participantname_away" class="item player-props-away">{{event.participantname_away}}</div>
            <div v-if="isAmerican && event.participantname_home" class="item player-props-away">{{event.participantname_home}}</div>
          </div>
        </div>
      </div>
      <div v-if="event.markets.length > 0" class="content-wrapper" @click="viewMore(event)">
        <div class="content" v-for="(market, index) in event.markets" :key="market.idfomarket">
          <markets :event="event" :markets="getMarketWithFirstSelection(market)" :playerPropsWidget="true" :diplayOnPage="'live-single-event'" :pricechangehighlight="true" :isLastMarket="index !== event.markets.length - 1"></markets>
        </div>
        </div>
      <div v-if="hasMoreThanThreeSelections(event)" class="view-more-container">
        <div class="view-more">
          <button @click="viewMore(event)" v-html="$t('PlayerProps.Widget.ViewMoreThenThree')"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import BettingOffer from '@/components/mixins/BettingOffer'
import Screen from '@/components/mixins/Screen'
import Gtm from '@/components/mixins/Gtm'
import markets from '@/components/sports/bettingoffer/markets'
import config from '@/config'

export default {
  name: 'PlayerProps',
  components: {markets},
  mixins: [
    BettingOffer,
    Gtm,
    Screen
  ],
  props: [
    'event',
    'isDialog',
    'oneEvent',
    'competitions'
  ],
  computed: {
    timeZone () {
      return window.ctsautoconf.TIMEZONE_DISPLAY
    },
    displayLogos () {
      const tabs = config.app.autoconf.FEATURES_TABS
      const tab = tabs && tabs['playerProps']
      return tab && tab.teamLogo
    },
    logosSource () {
      const tabs = config.app.autoconf.FEATURES_TABS
      const tab = tabs && tabs['playerProps']
      return (tab && tab.logoSource && tab.logoSource !== '') ? tab.logoSource : null
    },
    isAmerican () {
      return this.isAmericanSport(this.event, true)
    }
  },
  methods: {
    viewMore (event) {
      store.dispatch('overlayState/activatePlayerPropsDialogData', event)
    },
    hasMoreThanThreeSelections (event) {
      if (!event || !event.markets) {
        return false
      }
      const total = event.markets.reduce((sum, market) => {
        return sum + (market.selections ? market.selections.length : 0)
      }, 0)

      return total > 3
    },
    getMarketWithFirstSelection (market) {
      if (!market || !market.selections || market.selections.length === 0) {
        return []
      }
      let mar = {
        ...market,
        selections: [market.selections[0]]
      }
      return [mar]
    },
    headerClick (event) {
      this.goToEvent(event, false, false, false, false, true, undefined)
      if (this.isDialog) store.dispatch('overlayState/deactivatePlayerPropsDialogData', false)
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style scoped lang="stylus">
@import "~@/css/config"
.player-props
  width 100%
  &.one-event
    .props-container
      width 100%
.player_props_holder
  background var(--player-props-widget-holder-bgr)
  margin 0 5px 5px 0
  box-shadow none !important
  width auto
  @media mobile-big-and-below
    margin 0
  >>>.v-expansion-panel__container--active
    border-bottom 10px solid var(--player-props-widget-holder-bgr)
    @media mobile-big-and-below
      border-bottom 0
  >>>.v-expansion-panel__container--active
    .v-expansion-panel__header
      margin-bottom 0 !important
  >>>.v-expansion-panel__header
    border none !important
    height 43px
    padding 12px 8px
    .pp_header
      display flex
      align-items center
    .pp_icon
      background var(--pp-icon) 100% center no-repeat
      width 27px
      height 17px
      display inline-flex
      margin-right 10px
    .pp_title
      font-size 16px
      font-family 'Roboto Condensed Bold'
  >>>.v-expansion-panel__header__icon .v-icon
    color var(--player-props-widget-holder-openclose-icon-color) !important
  >>>.v-expansion-panel__body
    padding-left 5px
    .view-more-container
      .view-more
        padding-left 9px
  .props-container.props
    .props-holder
      .header-title
        margin-bottom 0
    .content-wrapper
      flex 0 0 150px
  .props-container
    width 290px
    height 270px
    margin-right: 10px
    background var(--player-props-content-bgr)
    color var(--player-props-widget-content-color)
    border-radius var(--player-props-widget-border-radius)
    overflow hidden
    display flex
    flex-direction column
    border var(--player-props-widget-border)
    &.team-logo
      height 277px
      .props-holder
        height 95px
    .props-holder
      padding 5px
      border-top-left-radius var(--player-props-widget-border-radius)
      border-top-right-radius var(--player-props-widget-border-radius)
      background: var(--player-props-widget-header-bgr)
      color var(--player-props-widget-header-color)
      height 48px
      font-size 15px
      font-family: 'Roboto Condensed Bold'
      line-height 17.58px
      display flex
      flex-direction column
      justify-content space-around
      cursor pointer
      .title-wrapper
        display flex
        align-items center
        justify-content space-between
        .item
          margin: 0
          flex 1
          &.time
            min-width: fit-content
            flex-shrink: 0
            margin: 0 5px
            white-space: nowrap
            width: auto
            display flex
            align-items center
            justify-content center
            color var(--player-props-widget-header-color-time-date)
          &.logo
            display flex
            height 30px
            width 30px
            overflow hidden
            img
              width 100%
              height 100%
              object-fit contain
          &.away
            display flex
            flex-direction column
            align-items flex-end
          &.logo.home
            justify-content left
          &.logo.away
            justify-content flex-end
            flex none
        .player-props-away
          text-align: end
        .player-props-home, .player-props-away
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          overflow: hidden
          text-overflow: ellipsis
          line-height: 1.2
          word-break: break-word
    .content-wrapper
      display flex
      flex-direction column
      overflow hidden
      flex 1
      margin-top: 10px
      margin-right: 5px
      cursor pointer
    .view-more-container
      display flex
      align-items baseline
      padding-left 5px
      margin-bottom 5px
      margin-top auto
      .view-more
        color var(--player-props-widget-view-more)
        font-size 12px
        font-family: 'Roboto Condensed Bold'
        display flex
        padding-left 5px
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/playerPropsWidget/PlayerPropsWidget.vue